import React from "react";
import { Helmet } from "react-helmet-async";
import Carousel from "./Carousel";
import Book from "./Book";
import About from "./About";
import Services from "./Service";
import Rooms from "./Rooms";
import Sliders from "./Testimonial";
import Attractions from "./Attraction";
import QuickFacts from "../common/QuickFacts";
import TrustStrip from "../common/TrustStrip";
import SectionDivider from "../common/SectionDivider";
import useScrollHighlight from "../../hooks/useScrollHighlight";

export default function Home() {
  useScrollHighlight();

  return (
    <>
      <Helmet>
        <title>HariKunj Resort Jodhpur – Luxury Heritage Resort in Rajasthan</title>
        <meta
          name="description"
          content="Experience authentic royal Rajasthani hospitality at HariKunj Resort, Jodhpur. Enjoy heritage luxury suites, gourmet Rajasthani dining, lush wedding lawns, and premier resort amenities."
        />
        <link rel="canonical" href="https://harikunjresort.com/" />
        <meta property="og:title" content="HariKunj Resort Jodhpur – Luxury Heritage Resort in Rajasthan" />
        <meta property="og:description" content="Experience authentic royal Rajasthani hospitality at HariKunj Resort, Jodhpur. Enjoy heritage luxury suites, gourmet Rajasthani dining, lush wedding lawns, and premier resort amenities." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://harikunjresort.com/" />
        <meta property="og:image" content="https://harikunjresort.com/assets/img/carousel-1.webp" />
      </Helmet>

      {/* Accessible Single H1 */}
      <h1 className="visually-hidden">
        HariKunj Resort Jodhpur — Top Luxury Heritage Resort in Chopasni, Rajasthan
      </h1>

      <Carousel />
      <TrustStrip />
      <Book />
      <QuickFacts pageTitle="Overview" />
      <About />
      <SectionDivider />
      <Rooms />
      <SectionDivider />
      <Services />
      <SectionDivider />
      <Sliders />
      <SectionDivider />
      <Attractions />
    </>
  );
}
